// @flow
import React from "react"
import classnames from "classnames"

type Props = {
  bgType?: "refund" | "fare" | "overloaded" | "money" | "",
  title: any,
}
const CommonModalBanner = ({ title, bgType = "" }: Props) => (
  <div
    className={classnames("CommonModalBanner", "_vexReset", {
      [`_${bgType}`]: bgType,
    })}
  >
    <div className="CommonModalBanner-title spTypo-headline spTypo-medium">{title}</div>
  </div>
)

export default CommonModalBanner
